import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { PageHeader } from "../components/layout";
import { adminApi } from "../lib/api";
import { useAdminAuth } from "../lib/auth";
import { EventTimeline } from "./run/event-timeline";
import { RunSummary } from "./run/run-summary";

const deliveryPollingStatuses = new Set(["PENDING", "ACCEPTED", "SENT", "DELIVERED", "UNKNOWN"]);

export function RunPage() {
  const { id } = useParams();
  const { token } = useAdminAuth();

  const run = useQuery({
    queryKey: ["admin", "run", id],
    queryFn: () => adminApi.run(token!, id!),
    enabled: Boolean(token && id),
    refetchOnWindowFocus: "always",
    refetchInterval: (query) => {
      const data = query.state.data;
      if (!data) return false;
      if (data.status === "RUNNING") return 3000;
      if (data.activityPending) return 5000;
      return deliveryPollingStatuses.has(data.delivery.status) ? 5000 : false;
    },
  });

  if (run.isLoading) {
    return (
      <div className="panel p-4 text-sm text-muted-foreground">
        Загружаем запуск...
      </div>
    );
  }
  if (run.error || !run.data) {
    return (
      <div className="panel p-4 text-sm text-danger">
        {run.error?.message ?? "Запуск не найден"}
      </div>
    );
  }

  const data = run.data;
  const routeName = data.funnel?.name ?? "Маршрут не определён";
  const backTo = data.funnelId
    ? `/funnels/${data.funnelId}/runs`
    : `/accounts/${data.accountId}/agents`;

  return (
    <div>
      <PageHeader
        title={`Запуск ${data.id.slice(0, 8)}`}
        description={`${routeName} · ${data.account.amoAccountId}`}
        backTo={backTo}
        backLabel={
          data.funnelId ? "К запускам агента" : "К агентам клиента"
        }
      />

      <RunSummary run={data} />

      <EventTimeline events={data.events} context={data} />
    </div>
  );
}
